import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuditLog } from '../models/AuditLog.model';

import { environment } from 'src/environments/environment';
import { UserProfileService } from './user.service';
import { Decrypt } from '../../pages/functions/functions';

const base_url = environment.api;

@Injectable({
  providedIn: 'root',
})
export class AuditService {

  /*
  |--------------------------------------------------------------------------
  | PREVENT DUPLICATES
  |--------------------------------------------------------------------------
  */

  private processedLogs = new Set<string>();

  constructor(
    private http: HttpClient,private userService:UserProfileService
  ) {}


   get locationId(): string {
      return localStorage.getItem('location') || '';
    }
  
   get token(): string {
      return localStorage.getItem('token') || '';
    }
  
    get headers() {
      return {
        headers: {
          'x-token': this.token
        }
      }
    }


  /*
  |--------------------------------------------------------------------------
  | MAIN REGISTER
  |--------------------------------------------------------------------------
  */

  registrar(log: AuditLog): void {

    /*
    |--------------------------------------------------------------------------
    | VALIDATE REQUIRED DATA
    |--------------------------------------------------------------------------
    */
    console.log(log);
    if (!log) {
      return;
    }

    /*
    |--------------------------------------------------------------------------
    | GENERATE UNIQUE KEY
    |--------------------------------------------------------------------------
    */

    const uniqueLogKey = JSON.stringify({

      actionName: log.actionName,
      moduleName: log.moduleName,
      movement: log.movement,
      urlEndpoint: log.urlEndpoint

    });

    /*
    |--------------------------------------------------------------------------
    | AVOID DUPLICATES
    |--------------------------------------------------------------------------
    */

    if (this.processedLogs.has(uniqueLogKey)) {
      return;
    }

    this.processedLogs.add(uniqueLogKey);

    /*
    |--------------------------------------------------------------------------
    | CLEAN CACHE
    |--------------------------------------------------------------------------
    */

    setTimeout(() => {
      this.processedLogs.delete(uniqueLogKey);
    }, 3000);

    /*
    |--------------------------------------------------------------------------
    | BODY
    |--------------------------------------------------------------------------
    */

    const body = {

      roleName:
        log.roleName || 'User',

      responsibleUser:
        log.responsibleUser || 'Unknown',

      actionName:
        log.actionName || 'UNKNOWN',

      moduleName:
        log.moduleName || 'General',

      movement:
        log.movement || '',

      urlEndpoint:
        log.urlEndpoint || '',

      ipAddress:
        log.ipAddress || '',

      browserInfo:
        navigator.userAgent,

      deviceInfo:
        this.getDeviceInfo(),

      previousData:
        log.previousData || null,

      newData:
        log.newData || null,

      statusName:
        log.statusName || 'SUCCESS',

      createdBy:
        log.createdBy || 'System',

      createdAt:
        new Date()

    };

    console.log('AUDITORIA:', body);

    /*
    |--------------------------------------------------------------------------
    | SAVE AUDIT
    |--------------------------------------------------------------------------
    */

    this.http
      .post(`${base_url}audit-logs?locationId=${this.locationId}`, body)
      .subscribe({

        next: () => {

          console.log(
            'Audit log saved successfully'
          );

        },

        error: (error) => {

          console.error(
            'Audit log error:',
            error
          );

        }

      });

  }

  /*
  |--------------------------------------------------------------------------
  | CREATE
  |--------------------------------------------------------------------------
  */

  logCreate(
    moduleName: string,
    movement: string,
    newData?: any
  ): void {

    this.registrar({

      roleName:
        Decrypt(this.userService.usuario.profile) || 'User',

      responsibleUser:
        Decrypt(this.userService.usuario.username) || 'Unknown',

      actionName: 'CREACION',

      moduleName,

      movement,

      newData:
        JSON.stringify(newData),

      statusName: 'CORRECTO',

      createdBy:
        Decrypt(this.userService.usuario.username) || 'System'

    });

  }

  /*
  |--------------------------------------------------------------------------
  | UPDATE
  |--------------------------------------------------------------------------
  */

  logUpdate(
    moduleName: string,
    movement: string,
    previousData?: any,
    newData?: any
  ): void {

    this.registrar({

      roleName:
        Decrypt(this.userService.usuario.profile) || 'User',

      responsibleUser:
        Decrypt(this.userService.usuario.username) || 'Unknown',

      actionName: 'UPDATE',

      moduleName,

      movement,

      previousData:
        JSON.stringify(previousData),

      newData:
        JSON.stringify(newData),

      statusName: 'CORRECTO',

      createdBy:
        Decrypt(this.userService.usuario.username) || 'System'

    });

  }

  /*
  |--------------------------------------------------------------------------
  | DELETE
  |--------------------------------------------------------------------------
  */

  logDelete(
    moduleName: string,
    movement: string,
    previousData?: any
  ): void {

    this.registrar({

      roleName:
        Decrypt(this.userService.usuario.profile) || 'User',

      responsibleUser:
        Decrypt(this.userService.usuario.username) || 'Unknown',

      actionName: 'DELETE',

      moduleName,

      movement,

      previousData:
        JSON.stringify(previousData),

      statusName: 'CORRECTO',

      createdBy:
        Decrypt(this.userService.usuario.username) || 'System'

    });

  }

  /*
  |--------------------------------------------------------------------------
  | LOGIN
  |--------------------------------------------------------------------------
  */

  logLogin(
    username: string
  ): void {

    this.registrar({

      roleName:
        Decrypt(this.userService.usuario.profile) || 'User',

      responsibleUser: username,

      actionName: 'LOGIN',

      moduleName: 'Authentication',

      movement:
        `${username} logged into the system`,

      statusName: 'CORRECTO',

      createdBy: username

    });

  }

  /*
  |--------------------------------------------------------------------------
  | EXPORT
  |--------------------------------------------------------------------------
  */

  logExport(
    moduleName: string,
    movement: string
  ): void {

    this.registrar({

      roleName:
        Decrypt(this.userService.usuario.profile) || 'User',

      responsibleUser:
        Decrypt(this.userService.usuario.username) || 'Unknown',

      actionName: 'EXPORT',

      moduleName,

      movement,

      statusName: 'CORRECTO',

      createdBy:
        Decrypt(this.userService.usuario.username) || 'System'

    });

  }

  /*
  |--------------------------------------------------------------------------
  | ERROR
  |--------------------------------------------------------------------------
  */

  logError(
    moduleName: string,
    movement: string,
    error?: any
  ): void {

    this.registrar({

      roleName:
        Decrypt(this.userService.usuario.profile) || 'User',

      responsibleUser:
        Decrypt(this.userService.usuario.username) || 'Unknown',

      actionName: 'ERROR',

      moduleName,

      movement,

      statusName: 'ERROR',

      newData:
        JSON.stringify(error),

      createdBy:
        Decrypt(this.userService.usuario.username) || 'System'

    });

  }




  
  /*
  |--------------------------------------------------------------------------
  | LIST
  |--------------------------------------------------------------------------
  */

 logList(
  page: number = 1,
  limit: number = 20,
  filters?: any
) {

  let params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString());

  if (filters) {

    if (filters.search) {
      params = params.set('search', filters.search);
    }

    if (filters.module) {
      params = params.set('module', filters.module);
    }

    if (filters.action) {
      params = params.set('action', filters.action);
    }

    if (filters.user) {
      params = params.set('user', filters.user);
    }

    if (filters.from) {
      params = params.set('from', filters.from);
    }

    if (filters.to) {
      params = params.set('to', filters.to);
    }

  }

  return this.http.get<any>(
    `${base_url}audit-logs`,
    {  ...this.headers,params }
  );

}

  /*
  |--------------------------------------------------------------------------
  | DEVICE INFO
  |--------------------------------------------------------------------------
  */

  private getDeviceInfo(): string {

    const userAgent = navigator.userAgent;

    if (userAgent.includes('Windows')) {
      return 'Windows';
    }

    if (userAgent.includes('Mac')) {
      return 'MacOS';
    }

    if (userAgent.includes('Linux')) {
      return 'Linux';
    }

    if (userAgent.includes('Android')) {
      return 'Android';
    }

    if (userAgent.includes('iPhone')) {
      return 'iPhone';
    }

    return 'Unknown Device';

  }

}